import React, { useEffect, useState } from 'react';
import DataTable from '../../../components/DataTable/DataTable';
import { ApplicationFunctions, useAuth } from '../../../contexts/authContext';
import { useNotifications } from '../../../contexts/notificationContext';
import WorkflowActionModel from '../../../models/WorkflowActionModel';
import DataService from "../../../services/data.service";
import Step_popup_AddAction from '../Popups/Step_popup_AddAction';

export type Props = {
    workflowDefinitionId: number
    workflowStepDefinitionId: number
}

const Step_tab_Actions: React.FC<Props> = ({ workflowDefinitionId, workflowStepDefinitionId }) => {
    const [data, setData] = useState<WorkflowActionModel[]>();
    const { handleResult, handleException } = useNotifications();
    const [showPopup, setShowPopup] = useState<boolean>(false)
    const { isAuthorizedForWorkflowDefinition } = useAuth();

    useEffect(() => {
        getTableData();
    }, [workflowStepDefinitionId]);

    function getTableData() {
        DataService.get<WorkflowActionModel[]>('api/v1/WorkflowActions/ByWorkflowStepDefinition/' + workflowStepDefinitionId)
            .then(response => {
                setData(response);
            })
            .catch(e => { handleException(e); });
    }

    function canDeleteRow(rowData: WorkflowActionModel): boolean {
        return isAuthorizedForWorkflowDefinition(ApplicationFunctions.UpdateWorkflowDefinition, rowData.workflowStepDefinition.workflowDefinitionId)
    }

    function deleteRow(rowData) {
        DataService.delete('api/v1/WorkflowActions/', rowData.id)
            .then(response => {
                handleResult(response);
                getTableData();
            })
            .catch(e => { handleException(e); });
    }

    return (
        <>
            <DataTable
                name='dtWorkflowEventCodeTasks'
                tableData={data}
                navigateTitle='Action'
                navigateUrl='/plm/WorkflowSetup/Action/'
                colInfos={[
                    { key: true, dataProp: 'id', visible: false },
                    { title: 'Display order', dataProp: 'buttonOrder', sort: 'asc' },
                    { title: 'Name', dataProp: 'name' },
                    { title: 'Next step', dataProp: 'nextWorkflowStepDefinition.title' },
                    { title: 'Task', dataProp: 'workflowTaskDefinition.name' },
                    { title: 'Active from', dataProp: 'beginDate', dataType: 'date' },
                    { title: 'Active until', dataProp: 'endDate', dataType: 'date' },
                    {
                        headerButtons: [{ text: "Add", icon: 'fa-plus-square', color: '#26A69A', onClick: () => setShowPopup(true), applicationFunctions: [ApplicationFunctions.UpdateWorkflowDefinition] }],
                        rowButtons: [{ text: "Delete", icon: 'fa-trash', color: '#F3565D', onClick: deleteRow, isVisible: canDeleteRow }]
                    }
                ]}
            />
            {showPopup && <Step_popup_AddAction show={showPopup} onHide={() => { getTableData(); setShowPopup(false) }} workflowDefinitionId={workflowDefinitionId} workflowStepDefinitionId={workflowStepDefinitionId} />}

        </>
    );
}
export default Step_tab_Actions;